import type { Chain } from "viem";
import { polygon, polygonAmoy } from "wagmi/chains";

// Single source of truth for the chain the app expects the wallet to be on.
//
// Chain selection is driven by NEXT_PUBLIC_CONTRACT_NET — and ONLY that var.
//   - "MAIN" → Polygon mainnet (chainId 137)
//   - "FORK" → local Hardhat fork (chainId 3133700); RPC URL taken from
//              NEXT_PUBLIC_RPC_URL or defaults to http://localhost:8545
//   - anything else / unset → Polygon Amoy testnet
//
// Fork mode is opt-IN via this explicit flag. NEXT_PUBLIC_RPC_URL alone never
// triggers fork mode — that var is purely the URL the fork talks to during
// local dev. A leaked NEXT_PUBLIC_RPC_URL in a non-FORK build is harmless.
// Avoid 31337: it is registered as GoChain Testnet, which can make MetaMask
// source native-token metadata and balances from the wrong network.
export const FORK_CHAIN_ID = 3133700;

const contractNet = process.env.NEXT_PUBLIC_CONTRACT_NET;

const polygonFork: Chain = {
  ...polygon,
  id: FORK_CHAIN_ID,
  name: "Polygon Fork (local)",
  // Real Polygon's nativeCurrency (symbol "POL") carried over on a made-up
  // chain id makes wallets try to match "POL" against their known-asset
  // registry, find nothing for this chain id, and show a "no asset" state
  // (observed in Trust Wallet) -- same class of problem as the 31337/GoChain
  // chain-id collision. Renaming it avoids the collision entirely.
  nativeCurrency: { name: "Fork POL", symbol: "fPOL", decimals: 18 },
  rpcUrls: {
    default: {
      http: [process.env.NEXT_PUBLIC_RPC_URL ?? "http://localhost:8545"],
    },
  },
  blockExplorers: {
    default: {
      name: "Otterscan",
      url: "http://localhost:5100",
    },
  },
};

function resolveChain(): Chain {
  if (contractNet === "FORK") return polygonFork;
  if (contractNet === "MAIN") return polygon;
  return polygonAmoy;
}

export const EXPECTED_CHAIN: Chain = resolveChain();

export const EXPECTED_CHAIN_ID: number = EXPECTED_CHAIN.id;
